import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import styled from "styled-components";
import Helmet from "react-helmet";

import style from "../utils/styles";
import { rhythm } from "../utils/typography";
import {
  Container,
  Content,
  Title,
  Sidebar,
  SidebarNews,
  InfoBlock,
  Main,
} from "../layouts/layouts";
import Gallery from "../layouts/gallery";
import { ButtonGreen, ButtonWhite } from "../layouts/button";

import homeHero from "../assets/homepage.jpg";
import photo from "../assets/etusivu-465x320-3521.png";
import img1 from "../assets/kunniakirja.jpg";
import thumb1 from "../assets/kunniakirja-100x100-1229.jpg";
import img2 from "../assets/vuodenyrittajanainen.jpg";
import thumb2 from "../assets/vuodenyrittajanainen-100x100-1925.jpg";
import cv from "../assets/kirsti_louko_cv.pdf";
import timanttiristi1 from "../assets/timanttiristi1.jpg";
import timanttiristi1Thumb from "../assets/timanttiristi1-thumb.jpg";
import timanttiristi2 from "../assets/timanttiristi2.jpg";
import timanttiristi2Thumb from "../assets/timanttiristi2-thumb.jpg";
import super1 from "../assets/super1.jpg";
import super1Thumb from "../assets/super1-thumb.jpg";
import super2 from "../assets/super2.jpg";
import super2Thumb from "../assets/super2-thumb.jpg";
import super3 from "../assets/super3.jpg";
import super3Thumb from "../assets/super3-thumb.jpg";
import super4 from "../assets/super4.jpg";
import super4Thumb from "../assets/super4-thumb.jpg";
import superjuttu from "../assets/Super_0220_Kirsti_Louko_Liika_kiltteys_kuluttaa_voimat.pdf";

const Hero = styled.div`
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  margin-bottom: ${rhythm(1)};
  margin-top: ${rhythm(2)};

  @media (min-width: 800px) {
    height: ${rhythm(24)};
    background-image: url(${homeHero});
    background-size: cover;
    background-position: top center;
    margin-top: 0;
  }
`;

const HeroInner = Container.extend`
  display: flex;
  flex-flow: column-reverse;
  justify-content: space-betweeen;
  align-items: center;
  height: 100%;

  @media (min-width: 800px) {
    flex-flow: row;
  }
`;
const HeroTitle = styled.h1`
  font-size: ${rhythm(1)};
  margin-top: ${rhythm(2)};

  @media (min-width: 800px) {
    line-height: 1.5;
    color: white;
    font-size: ${rhythm(2)};
    margin-top: initial;
  }
`;

const HeroImg = styled.img`
  max-width: 400px;
  width: 90%;
  height: auto;
  margin: auto;
  box-shadow: 10px 10px 25px rgba(0, 0, 0, 0.5);
  border-radius: 4px;

  @media (min-width: 800px) {
    color: white;
  }
`;

class IndexPage extends React.Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Kirsti Louko - Etusivu</title>
        </Helmet>
        <Hero>
          <HeroInner>
            <HeroTitle>
              PSYKOTERAPIA
              <br />
              SEKSUAALINEUVONTA
              <br />
              TYÖNOHJAUS
            </HeroTitle>
            <HeroImg src={photo} alt="Kirsti Louko" />
          </HeroInner>
        </Hero>
        <Content>
          <Main>
            <InfoBlock>
              <Title>ESITTELY</Title>
              <div className="content-info">
                <p>
                  Olen psykoterapeutti Kirsti Louko. Toimitilani sijaitsevat
                  Seinäjoella{" "}
                  <a
                    target="_self"
                    data-upfront-link-type="entry"
                    href="yhteystiedot/"
                  >
                    Ruukintie 25
                  </a>
                  .{" "}
                </p>
                <p>
                  Palveluitani ovat psykoterapia, seksuaalineuvonta(AMK) sekä
                  työnohjaus.&nbsp;
                </p>
                <p>
                  Tavoitteenani on asiakkaan toimintakyvyn parantaminen ja
                  ylläpito kokonaisvaltaisesti.{" "}
                </p>
                <p>
                  Alalta minulla on kokemusta jo vuodesta 1989 yksityisenä
                  fysioterapeutti-yrittäjänä.&nbsp;
                </p>
                <p>
                  Toimintaani säätelee ja valvoo eri terveydenhuollon tahot, mm.
                  Valvira sekä Kansaneläkelaitos(Kela).&nbsp;
                </p>
                <p>
                  Luonnollisesti minulla on ehdoton vaitiolovelvollisuus.
                  Yritykseni laatukäsikirja on tehty hyväksytysti v.2003.{" "}
                  <a rel="entry" href={cv} target="_blank">
                    Katso CV:ni
                  </a>
                </p>
              </div>
              <ButtonGreen to="/yhteystiedot">YHTEYSTIEDOT</ButtonGreen>
            </InfoBlock>

            <InfoBlock isGray>
              <Title>PSYKOTERAPIA</Title>
              <div className="content-info">
                <p>Psykoterapia voi auttaa sinua, jos sinulla on: </p>
                <ul>
                  <li>ahdistusta</li>
                  <li>masennusta</li>
                  <li>väsymystä</li>
                  <li>pelkoja</li>
                  <li>ongelmia ihmissuhteissa, työssä tai opiskelussa</li>
                </ul>
                <p>
                  Seksuaaliongelmat sekä ihmisen kokonaisvaltainen hyvinvointi
                  on monien koulutuksieni ja työkokemukseni ansiosta sydäntäni
                  lähellä.
                </p>
                <p>
                  Käyttämäni terapiasuuntaus on ratkaisukeskeinen psykoterapia.
                  Siinä mietitään yhdessä asiakkaan kanssa tavoite terapialle ja
                  pienet askeleet eli keinot, millä tavoite saavutetaan. Ratkaisukeskeisyys korostaa toiveikkuutta, voimavaroja ja
                  edistystä.                   
                  <p>Olen opiskellut traumaterapiasta syventävät opinnot ja olen myös
                  EMDR-terapeutti.</p> {" "}
                </p>
                <p>
                <a href="https://emdr.fi" target="_blank">Lue lisää EMDR:stä yhdistyksen kotisivuilta</a>{" "}
                </p>
              </div>
              <ButtonWhite to="/psykoterapia">LUE LISÄÄ</ButtonWhite>
            </InfoBlock>
          </Main>
          <Sidebar right>
            <Title>TAPAHTUMAT</Title>
            <SidebarNews>
              <div className="date">5.2.2020</div>
              <p className="news-p">
                Juttu SuPerin 02/20 lehdessä: Liika kiltteys kuluttaa voimat
              </p>
              {/* <a className="news-link" href="http://www.ilkka.fi/uutiset/maakunta/t%C3%A4ss%C3%A4-on-vuoden-yritt%C3%A4j%C3%A4nainen-1.1616474">Lue juttu</a> */}

              <Gallery
                images={[
                  { src: `${super1}`, thumb: `${super1Thumb}` },
                  { src: `${super2}`, thumb: `${super2Thumb}` },
                  { src: `${super3}`, thumb: `${super3Thumb}` },
                  { src: `${super4}`, thumb: `${super4Thumb}` },
                ]}
              />
              <p>
                {" "}
                <a href={superjuttu}>Lataa PDF</a>
              </p>
              <div className="date">4.12.2019</div>
              <p className="news-p">
                Suomen Yrittäjät myönsivät yrittäjäristin timanttiristin
              </p>
              {/* <a className="news-link" href="http://www.ilkka.fi/uutiset/maakunta/t%C3%A4ss%C3%A4-on-vuoden-yritt%C3%A4j%C3%A4nainen-1.1616474">Lue juttu</a> */}

              <Gallery
                images={[
                  { src: `${timanttiristi1}`, thumb: `${timanttiristi1Thumb}` },
                  { src: `${timanttiristi2}`, thumb: `${timanttiristi2Thumb}` },
                ]}
              />

              <div className="date">10.3.2015</div>
              <p className="news-p">Vuoden 2014 yrittäjänainen</p>
              <a
                className="news-link"
                href="http://www.ilkka.fi/uutiset/maakunta/t%C3%A4ss%C3%A4-on-vuoden-yritt%C3%A4j%C3%A4nainen-1.1616474"
              >
                Lue juttu
              </a>

              <Gallery
                images={[
                  { src: `${img1}`, thumb: `${thumb1}` },
                  { src: `${img2}`, thumb: `${thumb2}` },
                ]}
              />
            </SidebarNews>
          </Sidebar>
        </Content>
      </div>
    );
  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js